import * as React from "react";
import { Card, CardContent, Box, Grid, Typography,  } from "@material-ui/core";

import {
    DateField,
    DateInput,
    ReferenceField,
    TextField,
    FunctionField,
    FormWithRedirect,
    useTranslate,
    Labeled,
    SelectInput,
    BooleanInput,
    Toolbar,
    Edit,
    NumberInput,
} from "react-admin";
import { InputAdornment } from "@material-ui/core";




const Spacer = () => <Box m={1}>&nbsp;</Box>;

const OrderTitle = ({ record }) => {
    return <span> {record ? `Order Number :${record.order_number}` : ""}</span>;
};








const OrderForm = (props) => {
    const translate = useTranslate();
    return (
        <FormWithRedirect
            {...props}    
                render={(formProps) => (
                    <Box maxWidth="50em">
                        <Card>
                            <CardContent>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} md={8}>
                                        <Typography variant="h6" gutterBottom>
                                            {translate("Order")}
                                        </Typography>
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Labeled source="date">
                                                    <DateField source="date" record={formProps.record} />
                                                </Labeled>
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Labeled source="order number">
                                                    <TextField source="order_number" record={formProps.record} />
                                                </Labeled>
                                            </Grid>
                                        </Grid>
                                        <Spacer />
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <SelectInput
                                                    defaultValue=""
                                                    fullWidth={true}
                                                    source="status"
                                                    choices={[
                                                        {
                                                            id: "completed",
                                                            name: "completed",
                                                        },
                                                        {
                                                            id: "pending",
                                                            name: "pending",
                                                        },
                                                    ]}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={6}>
                                                <Box>
                                                    <SelectInput
                                                        defaultValue="buy"
                                                        fullWidth={true}
                                                        source="order_status"
                                                        choices={[
                                                            {
                                                                id: "buy",
                                                                name: "buy",
                                                            },
                                                            {
                                                                id: "rent",
                                                                name: "rent",
                                                            },
                                                        ]}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}>
                                        <Typography variant="h6" gutterBottom>
                                            {translate("Customer")}
                                        </Typography>
                                        <ReferenceField source="customer_id" label="Category Name" reference="users">
                                            <TextField source="userName" />
                                        </ReferenceField>

                                        <Spacer />

                                        <Typography variant="h6" gutterBottom>
                                            {translate("Store")}
                                        </Typography>
                                        <ReferenceField source="store_id" label="Store Name" reference="users">
                                            <TextField source="storeName" />
                                        </ReferenceField>

                                        <Spacer />

                                        <Typography variant="h6" gutterBottom>
                                            {translate("Shipping Address")}
                                        </Typography>
                                        <FunctionField render={(record) => `${record.address_one}, ${record.city}, ${record.state} ${record.zipcode}`} />
                                    </Grid>
                                </Grid>
                                <Spacer />

                                <Typography variant="h6" gutterBottom>
                                    {translate("items")}
                                </Typography>
                                <Box>
                                    <ReferenceField source="item_id" reference="items" styles={{ paddingLeft: 100 }}>
                                        <TextField source="name" />
                                    </ReferenceField>
                                    <NumberInput
                                        source="amount"
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        }}
                                        
                                    />
                                    <NumberInput
                                        source="fees"
                                        InputProps={{
                                            endAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        }}
                                        
                                    />
                                </Box>
                                {formProps.record.order_status === "rent" && (
                                    <>
                                        <Spacer />
                                        <Typography variant="h6" gutterBottom>
                                            {translate("Rent Range")}
                                        </Typography>
                                        <Box>
                                            <DateInput source="rented_from" />
                                            <DateInput source="rented_to" />
                                        </Box>
                                    </>
                                )}

                                <Spacer />
                                <Box>
                                    <BooleanInput source="customer_handshake" />
                                    <BooleanInput source="store_handshake" />
                                    <BooleanInput source="is_notified_two_days_before" />
                                    <BooleanInput source="is_notified_at_same_day" />
                                    <BooleanInput source="is_notified_at_return_day" />
                                    <BooleanInput source="customer_has_rated" />
                                    <BooleanInput source="store_has_rated" />
                                </Box>
                                <Spacer />
                            </CardContent>
                            <Toolbar
                                record={formProps.record}
                                basePath={formProps.basePath}
                                undoable={true}
                                invalid={formProps.invalid}
                                handleSubmit={formProps.handleSubmit}
                                saving={formProps.saving}
                                resource="orders"
                            />
                        </Card>
                    </Box>
                )
                
            }
            />
        
    );
};


export const OrderEdit = (props) => {
    return (
        <Edit
            title={<OrderTitle />}
            {...props}
            component="div"
        >
            <OrderForm />
        </Edit>
    );
};



